<template>
  <div>
    <el-drawer
      :title="type === 'add' ? '添加任务' : '编辑任务'"
      :visible="visible"
      :size="974"
      :destroy-on-close="true"
      :before-close="customCloseDrawer"
    >
      <div class="demo-drawer__content">
        <el-form :model="taskForm" :rules="rules" ref="taskRuleForm" label-width="140px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="代理名称">
                <span>{{ rowData.agentName }}</span>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="24">
              <el-form-item label="手机号码：">
                <span>{{rowData.phone }}</span>
              </el-form-item>
            </el-col> -->
            <el-col :span="18">
              <el-form-item :style="{ marginBottom: taskForm.settleMode ? '0' : '18px' }" label="结算方式:" prop="settleMode">
                <el-radio-group v-model="taskForm.settleMode" @change="changeSettlementType">
                  <el-radio :label="1">按答卷数量</el-radio>
                  <el-radio :label="2">按天</el-radio>
                  <el-radio :label="3">按阶梯计价</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="settlementType-style" v-if="taskForm.settleMode === 1">
                <div class="flex-box">
                  <el-form-item
                    label="单价(元):"
                    prop="settleRule.unitPriceYuan"
                    :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                  >
                    <el-input-number
                      placeholder=""
                      v-model="taskForm.settleRule.unitPriceYuan"
                      autocomplete="off"
                      controls-position="right"
                      :min="1"
                      :max="Infinity"
                      :precision="2"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span>元</span>
                </div>
                <div class="settlement-tips">
                  若用线上结算，请填写调查员到手金额，到手金额
                  <el-button type="text" @click="dialVisible = true">计算器</el-button>
                </div>
                <div class="flex-box">
                  <span class="pos-abs-box">
                    <i>*</i>
                    答卷数量:
                    <el-tooltip
                      effect="dark"
                      content="该数量仅为参考回收数量，调查员可超额上报答卷，您可与调查员线下协商上报数量，采用线上结算时，可按照实际上报答卷数量进行结算"
                      placement="top"
                    >
                      <div class="icon-wrap" style="margin-left: 4px">
                        <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                      </div>
                    </el-tooltip>
                  </span>
                  <el-form-item
                    label=""
                    prop="settleRule.expectedQuantity"
                    :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                  >
                    <el-input-number
                      placeholder=""
                      v-model="taskForm.settleRule.expectedQuantity"
                      autocomplete="off"
                      controls-position="right"
                      :min="1"
                      :max="Infinity"
                      :precision="0"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span>份</span>
                </div>
                <div class="settlement-tips" style="margin-bottom: 0">
                  <div style="display: flex">
                    <div>预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元</div>
                    <el-tooltip
                      effect="dark"
                      :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                      placement="top"
                    >
                      <div class="icon-wrap" style="margin-left: 4px">
                        <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div class="settlementType-style" v-if="taskForm.settleMode === 2">
                <div class="flex-box">
                  <el-form-item
                    label="单价（元）:"
                    prop="settleRule.unitPriceYuan"
                    :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                  >
                    <el-input-number
                      placeholder=""
                      v-model.number="taskForm.settleRule.unitPriceYuan"
                      autocomplete="off"
                      controls-position="right"
                      :min="1"
                      :max="Infinity"
                      :precision="2"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span>元</span>
                </div>
                <div class="settlement-tips">
                  若用线上结算，请填写调查员到手金额，到手金额
                  <el-button type="text" @click="dialVisible = true">计算器</el-button>
                </div>
                <div class="flex-box">
                  <span class="pos-abs-box">
                    <i>*</i>
                    天数:
                    <el-tooltip effect="light" placement="top">
                      <div slot="content">
                        <p>当天只要上报答卷即记为工作 1 天，该天数仅为参考工作天数</p>
                        <p>您可与调查员线下协商工作天数，采用线上结算时，可按照实际工作天数进行结算</p>
                      </div>
                      <div class="icon-wrap" style="margin-left: 4px">
                        <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                      </div>
                    </el-tooltip>
                  </span>
                  <el-form-item
                    label=""
                    prop="settleRule.expectedQuantity"
                    :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                  >
                    <el-input-number
                      placeholder=""
                      v-model.number="taskForm.settleRule.expectedQuantity"
                      autocomplete="off"
                      controls-position="right"
                      :min="1"
                      :max="Infinity"
                      :precision="0"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span>天</span>
                </div>
                <div class="settlement-tips" style="margin-bottom: 0">
                  <div style="display: flex">
                    <div>预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元</div>
                    <el-tooltip
                      effect="dark"
                      :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                      placement="top"
                    >
                      <div class="icon-wrap">
                        <span class="icon-font ico-tips">&#xe65b;</span>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div class="settlementType-style" v-if="taskForm.settleMode === 3">
                <el-form-item class="is-require-task" style="margin-bottom: 0" label="单价(元):">
                  <div
                    class="flex-settlement"
                    v-for="(item, index) in taskForm.settleRule.tiers"
                    :key="index"
                    :style="{ marginBottom: index === taskForm.settleRule.tiers.length - 1 ? '0px' : '5px' }"
                  >
                    <span style="margin-right: 8px" v-show="index === 0">每天</span>
                    <el-form-item label>
                      <el-input-number
                        v-if="index === 0"
                        :disabled="true"
                        placeholder=""
                        v-model="item.quantityLowerBound"
                        autocomplete="off"
                        controls-position="right"
                        :min="0"
                        :max="Infinity"
                        :precision="0"
                      >
                      </el-input-number>
                      <el-input-number
                        v-if="index > 0"
                        :disabled="true"
                        placeholder=""
                        :value="taskForm.settleRule.tiers[index - 1].quantityUpperBound * 1"
                        autocomplete="off"
                        controls-position="right"
                        :min="0"
                        :max="Infinity"
                        :precision="0"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span style="margin: 0 8px">份 &lt; 完成量 ≤</span>
                    <el-form-item
                      label
                      :prop="'settleRule.tiers[' + index + '].quantityUpperBound'"
                      :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                    >
                      <el-input-number
                        placeholder=""
                        v-model="item.quantityUpperBound"
                        autocomplete="off"
                        controls-position="right"
                        :min="index > 0 ? taskForm.settleRule.tiers[index - 1].quantityUpperBound * 1 + 1 : 1"
                        :max="Infinity"
                        @change="val => currentInputNumber(val, item, index)"
                        :precision="0"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span style="margin: 0 8px">份，按完成量</span>
                    <el-form-item
                      label
                      :prop="'settleRule.tiers[' + index + '].unitPriceYuan'"
                      :rules="[
                        {
                          required: true,
                          message: ' ',
                          trigger: 'change'
                        }
                      ]"
                      style="margin-left: 10px"
                    >
                      <el-input-number
                        placeholder=""
                        v-model.number="item.unitPriceYuan"
                        autocomplete="off"
                        controls-position="right"
                        :min="1"
                        :max="Infinity"
                        :precision="2"
                      >
                      </el-input-number>
                    </el-form-item>
                    <span style="margin-left: 8px">元/份</span>
                    <el-button v-if="index === 0" @click="handleSettlement('add', index)" class="btn-style" type="text"
                      ><i class="icon-font">&#xe68c;</i></el-button
                    >
                    <el-button
                      v-else-if="index === taskForm.settleRule.tiers.length - 1"
                      @click="handleSettlement('remove', index)"
                      class="btn-style"
                      type="text"
                      ><i class="icon-font">&#xe68a;</i></el-button
                    >
                    <!-- <el-button @click="handleSettlement(index=== taskForm.ladderSettlement.length-1 ? 'add' : 'remove')" class="btn-style" type="text"> {{index=== 0? '+':'-'}}</el-button> -->
                  </div>
                  <div class="settlement-tips left-0">
                    若用线上结算，请填写调查员到手金额，到手金额
                    <el-button type="text" @click="dialVisible = true">计算器</el-button>
                  </div>
                </el-form-item>
                <div class="flex-box">
                  <el-form-item
                    style="margin-bottom: 0"
                    label="天数:"
                    prop="settleRule.expectedQuantity"
                    :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                  >
                    <el-input-number
                      placeholder=""
                      v-model.number="taskForm.settleRule.expectedQuantity"
                      autocomplete="off"
                      controls-position="right"
                      :min="1"
                      :max="Infinity"
                      :precision="0"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span>天</span>
                </div>
              </div>
            </el-col>
            <el-col :span="14">
              <el-form-item label="任务名称:" prop="taskName">
                <el-input placeholder="请输入任务名称" v-model="taskForm.taskName" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="截止时间:" prop="endTime">
                <el-date-picker
                  type="datetime"
                  placeholder="选择时间"
                  v-model="taskForm.endTime"
                  style="width: 100%"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="描述:" prop="description">
                <el-input placeholder="请输入描述" v-model="taskForm.description" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="执行要求:" prop="executionRequirement">
                <el-input placeholder="请输入执行要求" v-model="taskForm.executionRequirement" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="质控标准:" prop="qualityControlStandard">
                <el-input placeholder="请输入质控标准" v-model="taskForm.qualityControlStandard" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="结算标准:" prop="settleStandard">
                <el-input placeholder="请输入质控标准" v-model="taskForm.settleStandard" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item required label="代理是否审核答卷:">
                <el-switch v-model="taskForm.agencyApproveFlag"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="submitForm('taskRuleForm')" :loading="loading">{{
          loading ? '提交中 ...' : '确 定'
        }}</el-button>
      </div>
    </el-drawer>
    <over-mask
      :dialogVisible="dialVisible"
      @handleClose="
        () => {
          dialVisible = false
        }
      "
    ></over-mask>
  </div>
</template>
<script>
import OverMask from '@/views/survey/offline/components/overMask/OverMask.vue'
import { putOfflineTask } from '@/api/wenjuan/offline.js' //编辑任务API
import { plCreat } from '@/api/wenjuan/addList.js' // 添加任务API
import { addList, updateWjentrusttask, addListForEntrust } from '@/api/wenjuan/publishQuestion' // 委托代理添加任务API
import GlobalConfig from '@/global/config'
export default {
  components: { OverMask },
  props: ['visible', 'rowData', 'type'],
  watch: {
    visible: {
      handler: function (value) {
        console.log('value', this.rowData)
        const val = JSON.parse(JSON.stringify(this.rowData))
        if (value === true && this.type === 'edit') {
          this.taskForm = {
            agencyApproveFlag: val.agencyApproveFlag === 1 ? true : false,
            agentName: this.rowData.agentName,
            phone: this.rowData.phone,
            taskName: val.taskName,
            endTime: val.endTime,
            description: val.description,
            executionRequirement: val.executionRequirement,
            qualityControlStandard: val.qualityControlStandard,
            settleStandard: val.settleStandard,
            settleMode: val.settleMode,
            settleRule: val.settleRule || {
              unitPriceYuan: undefined, //单价 多少元/天  多少元/份
              expectedQuantity: undefined, // 数量 多少份 | 多少天
              tiers: [
                {
                  quantityLowerBound: 0,
                  quantityUpperBound: undefined,
                  unitPriceYuan: undefined
                }
              ]
            }
          }
        } else if (value === true && this.type === 'add') {
          this.taskForm = {
            agencyApproveFlag: false,
            agentName: this.rowData.agentName,
            phone: this.rowData.phone,
            taskName: '',
            endTime: null,
            description: '',
            executionRequirement: '',
            qualityControlStandard: '',
            settleStandard: '',
            settleMode: '',
            settleRule: {
              unitPriceYuan: undefined, //单价 多少元/天  多少元/份
              expectedQuantity: undefined, // 数量 多少份 | 多少天
              tiers: [
                {
                  quantityLowerBound: 0,
                  quantityUpperBound: undefined,
                  unitPriceYuan: undefined
                }
              ]
            }
          }
        }
      },
      deep: false
    },
    'taskForm.settleRule.tiers': {
      handler: function (value) {
        console.log(value)
        const cloneValue = JSON.parse(JSON.stringify(value))
        // cloneValue
        cloneValue.forEach((it, i, arr) => {
          console.log(it)
          if (i > 0) {
            it.quantityUpperBound = arr[i - 1].quantityUpperBound + 1
          }
        })
        console.log(cloneValue)
        // this.taskForm.settleRule.tiers = [];
      },
      deep: true
    }
  },
  computed: {
    totalPriceYuan () {
      if (this.taskForm.settleRule.expectedQuantity && this.taskForm.settleRule.unitPriceYuan) {
        return (this.taskForm.settleRule.expectedQuantity * this.taskForm.settleRule.unitPriceYuan).toFixed(2)
      } else {
        return 0
      }
    },
    totalSaleYuan () {
      if (this.taskForm.settleRule.expectedQuantity && this.taskForm.settleRule.unitPriceYuan) {
        return ((1 + this.accRate * 1) * (this.taskForm.settleRule.expectedQuantity * this.taskForm.settleRule.unitPriceYuan)).toFixed(2)
      } else {
        return 0
      }
    },
    accountingRateVal() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '6.5%' : `${accountingRate}%`
    },
    accRate() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '0.065' : (accountingRate / 100).toFixed(3)
    }
  },
  data() {
    const cursomVaild = (rule, value, callback) => {
      if (index > 0) {
        if (value < this.taskForm.ladderSettlement[index - 1].endAmount * 1 + 1) {
          callback(new Error('当前数量必须大于起始份数'))
        } else {
          callback()
        }
      } else {
        if (value < this.taskForm.ladderSettlement[index].startAmount) {
          callback(new Error('当前数量必须大于起始份数'))
        } else {
          callback()
        }
      }
    }
    return {
      formLabelWidth: 120,
      loading: false,
      dialVisible: false,
      taskForm: {
        executorName: '',
        executorPhone: '',
        taskName: '',
        endTime: null,
        description: '',
        executionRequirement: '',
        qualityControlStandard: '',
        settleStandard: '',
        settleMode: 1,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        },
        agencyApproveFlag: false
      },
      rules: {
        taskName: [{ type: 'string', required: true, message: '请输入任务名称', trigger: 'change' }],
        settleMode: [{ required: true, message: '请选择结算方式', trigger: 'change' }],
        endTime: [{ required: true, message: '请选择截止时间', trigger: 'change' }]
      }
    }
  },
  methods: {
    // 监听input-number值的变化
    currentInputNumber(val, item, currentIndex) {
      const baseSettleRule = JSON.parse(JSON.stringify(this.taskForm.settleRule))
      baseSettleRule.tiers.forEach((it, i, arr) => {
        if (i > currentIndex) {
          it.quantityUpperBound = arr[i - 1].quantityUpperBound + 1
        }
      })
      this.taskForm.settleRule = {
        ...this.taskForm.settleRule,
        tiers: baseSettleRule.tiers
      }
    },
    // 切换结算方式
    changeSettlementType(val) {
      console.log(val)
      this.$refs['taskRuleForm'].clearValidate()

      this.taskForm = {
        ...this.taskForm,
        settleMode: val,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      }
    },
    handleSettlement(type, index) {
      console.log(type)
      if (type === 'add') {
        const validateArr = []
        this.taskForm.settleRule.tiers.forEach((it, i) => {
          validateArr.push(`settleRule.tiers[${i}].quantityUpperBound`)
          validateArr.push(`settleRule.tiers[${i}].unitPriceYuan`)
        })
        let validFlag = false
        validateArr.forEach(item => {
          this.$refs['taskRuleForm'].validateField(
            validateArr,
            valid => (validFlag = valid ? false : true) // 定义是否通过表单验证
          )
        })
        if (validFlag) {
          if (this.taskForm.settleRule.tiers.length < 5) {
            const lastTiers = this.taskForm.settleRule.tiers[this.taskForm.settleRule.tiers.length - 1]
            const lastObj = { quantityUpperBound: lastTiers.quantityUpperBound, unitPriceYuan: lastTiers.unitPriceYuan }

            const flagDouble = Object.values(lastObj).includes(undefined)
            if (flagDouble) {
              this.$message.error('请完善表单项')
              return
            }
            const cloneLadderSettlement = this.taskForm.settleRule.tiers
            cloneLadderSettlement.push({
              quantityLowerBound: '',
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            })
            this.taskForm.settleRule.tiers = cloneLadderSettlement
          } else {
            this.$message.error('最多只能添加5条数据')
          }
        } else {
          this.$message.error('请完善表单项')
        }
      } else if (type === 'remove') {
        const cloneLadderSettlement = this.taskForm.settleRule.tiers

        this.taskForm.settleRule.tiers = cloneLadderSettlement.filter((it, i) => index !== i)
      }
    },
    cancelForm(formName) {
      // this.$refs['taskRuleForm'].resetFields();
      console.log(this.$refs['taskRuleForm'].fields)
      this.$emit('callbackClose', false)
    },
    customCloseDrawer() {
      this.$emit('callbackClose', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let postData = {}
          if (this.taskForm.settleMode === 3) {
            const cloneLadderSettlement = [...this.taskForm.settleRule.tiers]
            cloneLadderSettlement.forEach((it, i, arr) => {
              if (i > 0) {
                it.quantityLowerBound = arr[i - 1].quantityUpperBound * 1
              }
            })
            postData = {
              ...this.taskForm,
              agencyApproveFlag: this.taskForm.agencyApproveFlag === true ? 1 : 0,
              settleRule: {
                ...this.taskForm.settleRule,
                tiers: cloneLadderSettlement
              }
            }
            // postData.ladderSettlement =cloneLadderSettlement;
          } else {
            postData = { ...this.taskForm, agencyApproveFlag: this.taskForm.agencyApproveFlag === true ? 1 : 0 }
          }
          if (this.type === 'add') {
            addListForEntrust([
              {
                ...postData,
                taskId: this.rowData.taskId,
                executionBy: this.rowData.executionBy,
                id: this.rowData.id,
                status: this.rowData.status,
                surveyId: this.rowData.surveyId,
                agentTenantId: this.rowData.agentTenantId,
                agentId: this.rowData.agentId,
                agentType: this.rowData.agentType,
                agentName: this.rowData.agentName
              }
            ]).then(({ data }) => {
              if (data.code === 0) {
                this.$alert('您已发布任务,等待代理承接任务', '已发布代理任务', {
                  confirmButtonText: '我知道了',
                  callback: action => {
                    this.$emit('callbackClose', false, 'isSubmit')
                  }
                })
                // this.$message.success('添加成功')
                // this.$emit('callbackClose', false, 'isSubmit')
              } else {
                this.$message.error(data.msg)
              }
            })
          } else {
            updateWjentrusttask({
              ...postData,
              taskId: this.rowData.taskId,
              executionBy: this.rowData.executionBy,
              id: this.rowData.id,
              status: this.rowData.status,
              surveyId: this.rowData.surveyId,
              agentTenantId: this.rowData.agentTenantId,
              agentId: this.rowData.agentId,
              agentType: this.rowData.agentType,
              agentName: this.rowData.agentName
            }).then(({ data }) => {
              if (data.code === 0) {
                // this.$message.success('修改成功')
                // this.$emit('callbackClose', false, 'isSubmit')
                this.$alert('您已修改此任务,等待代理承接任务', '已修改代理任务', {
                  confirmButtonText: '我知道了',
                  callback: action => {
                    this.$emit('callbackClose', false, 'isSubmit')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
          console.log('postData:', postData, this.rowData)
        } else {
          console.log('error submit!!', valid)
          return false
        }
      })
    }
  },
  created() {}
}
</script>
<style lang="scss">
.demo-drawer__content {
  padding: 30px;
  height: calc(100% - 50px);
  overflow: auto;
  .settlementType-style {
    .is-require-task {
      .el-form-item__label {
        &::before {
          content: '*';
          color: #e34152;
          margin-right: 4px;
        }
      }
    }
    .flex-box {
      display: flex;
      position: relative;
      & > span {
        line-height: 32px;
        margin-left: 8px;
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        font-weight: 400;
        font-family: PingFangSC-Regular;
      }
      .pos-abs-box {
        position: absolute;
        display: flex;
        justify-content: flex-end;
        width: 128px;
        padding-right: 12px;
        i {
          content: '*';
          color: #e34152;
          margin-right: 4px;
        }
      }
    }
    margin-bottom: 16px;
    padding: 12px;
    background-color: rgba(242, 242, 242, 0.624);
    .el-form-item {
      margin-bottom: 8px;
      .el-input-number {
        width: 88px;
        background: #f2f5fa;
        .el-input__inner {
          padding-left: 5px !important;
          padding-right: 25px !important;
        }
      }
      .el-input-number.is-controls-right .el-input__inner {
        background: #f2f5fa;
      }
      .el-input.is-disabled .el-input__inner {
        border-color: rgba(221, 221, 221, 1);
      }
      .el-input-number__decrease,
      .el-input-number__increase {
        background: #f2f5fa;
        .el-icon-arrow-down,
        .el-icon-arrow-up {
          color: rgba(0, 0, 0, 0.65);
          border-color: rgba(221, 221, 221, var(--tw-border-opacity));
        }
      }
    }
    .btn-style {
      margin-left: 5px;
    }
    .settlement-tips {
      margin-left: 140px;
      font-size: 12px;
      margin-bottom: 8px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      .el-button {
        font-size: 12px;
      }
      &.left-0 {
        margin-left: 0;
        margin-bottom: 0;
      }
    }
    .flex-settlement {
      display: flex;
      margin-bottom: 5px;
      align-items: center;
      .settlement-tips {
        margin-bottom: 0;
      }
      .el-form-item {
        margin-bottom: 0;
      }
      .el-input-number {
        width: 88px;
        background: #f2f5fa;
      }
      span {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .icon-wrap {
      margin-left: 4px;
      .ico-tips {
        color: rgba(0,0,0,0.35);
      }
    }
  }
}
.demo-drawer__footer {
  padding-top: 9px;
  height: 50px;
  background: #fff;
  border-top: 1px solid #f5f5f5;
  text-align: right;
}
</style>
